module.exports = __webpack_public_path__ + "img/金属材料学1_1.fcc178ba.png";